<micro-picklist title="Network Elements" [all]="all" [(selectedIds)]="selectedItems" (selectedIdsChange)="onNgModelChange($event)"></micro-picklist>

